//import axios from 'axios';
//import Promise from 'bluebird';
import SearchOptions from 'src/search2/SearchOptions';
import Server from "../new/server/Server";

/*Promise.config({
    cancellation: true
});*/

export default class VerseVersions {

    /**
     *
     * @param {number} startIndex
     * @param {number} endIndex
     * @param {SourceTextCache} sourceTextCache
     */
    /*static cacheRange(startIndex, endIndex, sourceTextCache) {
        return new Promise((resolve, reject) => {
            Server.newRequest().get(`verse-versions/verses/${startIndex}/${endIndex}`)
                    .then(response => {
                        if (!Array.isArray(response)) {
                            throw new Error('Array expected');
                        }
                        response.forEach(verse => {
                            //const verseTexts = verse.versions
                            //        .map(version => new VerseText(version.versionIndex, version.text));
                            const text = new Map(verse.versions.map(version => [version.versionIndex, version.text]));
                            sourceTextCache.putVerse(verse.index, text);
                        });
                        resolve();
                    })
                    .catch(error => reject(error));
        });
    }*/

    /*static getRange(startIndex, endIndex, selectedVersions) {
        const versionIndexes = Array.isArray(selectedVersions) ? selectedVersions.map(version => version.index) : [];
        const versions = JSON.stringify(versionIndexes);
        return this._doGet(`http://localhost:3001/verse-range?s=${startIndex}&e=${endIndex}&v=${versions}`);
    }

    static getRange2(startIndex, endIndex, versionIndexes) {
        const versions = JSON.stringify(versionIndexes);
        return this._doGet(`http://localhost:3001/verse-range?s=${startIndex}&e=${endIndex}&v=${versions}`);
    }*/

    /*static getRange(startIndex, endIndex) {
        return this._doGet(`verse-versions/verses/${startIndex}/${endIndex}`);
    }*/

    /*static getForBook(bookId, selectedVersions) {
        const versionsString = selectedVersions.toString();
        return this._doGet(`http://localhost:3001/verse-versions/book/${bookId}?v=${versionsString}`);
    }*/

    /*static getBookForVerse(verseIndex) {
        return this._doGet(`verse-versions/verse/${verseIndex}`);
    }*/

    public static search(text: string, options: SearchOptions, limit: number, includeText: boolean) {
        const textEncoded = encodeURIComponent(text);
        const language = encodeURIComponent(options.language);
        const versions = JSON.stringify(options.versionIndexes);
        const searchAllVersions = options.searchAllVersions ? '1' : '0';
        const searchStems = options.searchStems ? '1' : '0';
        const includeTextStr = includeText ? '1' : '0';
        //limit = Number(limit);

        return new Promise((resolve, reject) => {
            //const source = axios.CancelToken.source();
            //onCancel(() => source.cancel());
            Server.newRequest().get(`verse-versions/search?q=${textEncoded}&lang=${language}&vers=${versions}&all=${searchAllVersions}&stems=${searchStems}&lim=${limit}&text=${includeTextStr}`)
                    //{ cancelToken: source.token })
                    .then(response => {
                        /*if (!Array.isArray(response.data)) {
                            throw new Error('Array expected');
                        }*/
                        resolve(response);
                    })
                    .catch(error => reject(error));
        });
    }

    //static _doGet(url) {
    //    return new Promise((resolve, reject/*, onCancel*/) => {
            /*const source = axios.CancelToken.source();
            onCancel(() => source.cancel());
            axios.get(url, { cancelToken: source.token })*/
    /*        Server.newRequest().get(url)
                    .then(response => {
                        if (!Array.isArray(response)) {
                            throw new Error('Array expected');
                        }
                        resolve(response);
                    })
                    .catch(error => reject(error));
        });
    }*/
}
